import { string } from 'yup'

const requiredField = message => string().required(message || 'Please enter a value')

export default requiredField
